import React, { useEffect, useMemo } from 'react';
import {
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
  detectMobileStore,
  getStoreUrl
} from '../utils/downloadLinks';

function AppDownloadRedirect() {
  const store = useMemo(
    () => detectMobileStore(window.navigator.userAgent),
    []
  );

  useEffect(() => {
    const targetUrl = getStoreUrl(store);

    if (targetUrl) {
      window.location.assign(targetUrl);
    }
  }, [store]);

  const showFallback = store === 'unknown';

  return (
    <div className="download-redirect-page">
      <div className="download-redirect-card">
        <p className="download-redirect-eyebrow">Download our app</p>
        <h1>{showFallback ? 'Choose your store' : 'Redirecting you now'}</h1>
        <p>
          {showFallback
            ? 'We could not detect your device automatically.'
            : 'If nothing happens, use one of the store links below.'}
        </p>
        <div className="download-redirect-actions">
          <a href={APP_STORE_URL}>Download on the App Store</a>
          <a href={GOOGLE_PLAY_URL}>Get it on Google Play</a>
        </div>
      </div>
    </div>
  );
}

export default AppDownloadRedirect;
